import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {
  SearchState,
  SearchStateService,
} from '../_core/services/search-state.service';
import { omitBy, isNull } from 'lodash-es';
import { SearchService } from '../_core/services/search.service';
import { Router } from '@angular/router';
import { Subject, Subscription, forkJoin, takeUntil } from 'rxjs';
import { LoadingSpinnerService } from '../_core/services/loading-spinner.service';
import { CURRENT_TENNANT } from '../app.component';
import {
  ActionPasser,
  Dropdown,
  ErrorMessages,
  GMList,
  Grandmaster,
  Validator,
  Logger,
  BahamutHelper,
  Checkbox
} from 'lo-bahamut';
import { CareFindrTenantConfigurationService } from '../_core/apiV2/services/care-findr-tenant-configuration.service';
import {level} from "lo-bahamut-v1/types";
import {HandlebarsService} from "../_core/services/handlebars.service";
import {ProviderSearchService} from "../_core/apiV2/services/provider-search.service";

export type option = {
  value: string;
  description: string;
};

@Component({
  selector: 'app-search-start-v2',
  templateUrl: './search-start-v2.component.html',
  styleUrls: ['./search-start-v2.component.scss']
})

export class SearchStartV2Component implements OnInit, OnDestroy {
  private url: string = "../../assets/search-page.hbs";
  private _data: any;
  private subscriptionData!: Subscription;
  isPlanDropDownEnabled = true;
  isSpecialityHeaderNeedToChange = false;
  planOptions: option[] = [];
  specialtyOptions: level[] = [];
  debounceDelay = 300;
  destroyed$ = new Subject<void>();

  searchState: SearchState = {
    Query: {
      sortBy: 'distance-asc',
    },
    Extra: {},
  };

  printState: SearchState = {
    Query: {},
    Extra: {},
  };

  public get data(): any { return this._data; }
  @ViewChild('gm') gm: Grandmaster;

  constructor(private searchService: SearchService,
              public actionPasser: ActionPasser,
              public gmList: GMList,
              private loadingSpinnerService: LoadingSpinnerService,
              public logger: Logger,
              private lobhelper: BahamutHelper,
              public errorMessages: ErrorMessages,
              public grandmaster: Grandmaster,
              public validator: Validator,
              private hbs: HandlebarsService,
              private searchStateService: SearchStateService,
              private tenantConfigService: CareFindrTenantConfigurationService,
              private providerSearchService: ProviderSearchService,
              private router: Router,
  ) {
  }
  ngOnInit() {
    this.loadingSpinnerService.showLoader();
    const tenantComponentJs$ = this.tenantConfigService.getTenantComponentBluePrint({page_name: 'patient-search', tenant: CURRENT_TENNANT});
    // const tenantComponentJs$ = this.providerSearchService.multiTenantProviderDetailCareFindr({uid: "NPI:1952543647", "x-tenant-id": 'riverspring'});

    forkJoin([tenantComponentJs$])
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: ([componentJsResponse]) => {
          let response: any = {}
          if (typeof componentJsResponse === "string") {
            response = JSON.parse(componentJsResponse);
          } else {
            response = componentJsResponse;
          }
          this._data = response.componentsConfig;
          this.errorMessages.defaultErrorMessages = response.errorMessages;
          console.log(this.data);
        },
        error: (err) => {
          if (err.status === 403) {
            console.error('You are not authorized to view this', err);
            this.router.navigate(['error-handler'], {state: { msg:"Access denied"}});
          } else {
            console.error('Please try again later or contact support.', err);
          }
        },
        complete: () => {
          this.loadingSpinnerService.hideLoader();
        }
      });

    this.actionPasser.groupEmitter$.subscribe((group: any) => {
      // console.log(group)
      if (group !== undefined && Object.keys(group).length !== 0) {
        switch (group[0].groupName) {
          case "setupInitialScreen":
            break;
          case "clearFormData":
            if(this.isPlanDropDownEnabled) {
              let planDropdownUK = this.lobhelper.getDesiredChildUK(group[1].uniqueKey, "planDropdown");
              let planDropdownRef = this.gmList.gmList[planDropdownUK].reference;
              planDropdownRef.data = [];
            }

            let insideContainer1 = this.lobhelper.getDesiredChildUK(group[1].uniqueKey, "insideContainer1");
            let insideContainer2 = this.lobhelper.getDesiredChildUK(group[1].uniqueKey, "insideContainer2");
            let locationDropdownUK = this.lobhelper.getDesiredChildUK(insideContainer1, "locationDropdown");
            let locationDropdownRef = this.gmList.gmList[locationDropdownUK].reference;
            locationDropdownRef.data = undefined;

            let distanceDropdownUK = this.lobhelper.getDesiredChildUK(insideContainer1, "distanceDropdown");
            let distanceDropdownRef = this.gmList.gmList[distanceDropdownUK].reference;
            distanceDropdownRef.data = [];
            distanceDropdownRef.data = ['25'];

            let nameInputUK = this.lobhelper.getDesiredChildUK(insideContainer2, "nameInput");
            let nameInputRef = this.gmList.gmList[nameInputUK].reference;
            nameInputRef.data = "";

            let providerOrSpecialityDropdownUK = this.lobhelper.getDesiredChildUK(insideContainer2, "providerOrSpecialityDropdown");
            let providerOrSpecialityDropdownRef = this.gmList.gmList[providerOrSpecialityDropdownUK].reference;
            providerOrSpecialityDropdownRef.clearComponent();

            break;
          case "submitFormData":
            const anythingInvalid2 = this.validator.checkIfAnythingInvalid(group[1].uniqueKey);
            if (anythingInvalid2) {
              return
            }
            this.handleSubmit(group);
            break;
          case "slider-dropdown-group": {
            var first = this.gmList.gmList[group[0].uniqueKey].reference;
            var second = this.gmList.gmList[group[1].uniqueKey].reference;
            if (first.data != second.data) {
              if (second.componentRef.componentType == Dropdown) {
                second.checkboxes.forEach((cb: Checkbox) => {
                  cb.checked = false;
                })
                second.data = [first.data];
              } else {
                second.data = first.data;
              }
            }
          }
        }
      }
    });
  }

  handleSubmit(group: any) {
    let planDropdownUK = this.lobhelper.getDesiredChildUK(group[1].uniqueKey, "planDropdown");
    let planDropdownRef = this.gmList.gmList[planDropdownUK].reference;
    if(!planDropdownRef.hide) {
      this.searchState.Query.programType = planDropdownRef.data;
    }

    let insideContainer1 = this.lobhelper.getDesiredChildUK(group[1].uniqueKey, "insideContainer1");
    let insideContainer2 = this.lobhelper.getDesiredChildUK(group[1].uniqueKey, "insideContainer2");
    let locationDropdownUK = this.lobhelper.getDesiredChildUK(insideContainer1, "locationDropdown");
    let locationDropdownRef = this.gmList.gmList[locationDropdownUK].reference;

    let distanceDropdownUK = this.lobhelper.getDesiredChildUK(insideContainer1, "distanceDropdown");
    let distanceDropdownRef = this.gmList.gmList[distanceDropdownUK].reference;

    let nameInputUK = this.lobhelper.getDesiredChildUK(insideContainer2, "nameInput");
    let nameInputRef = this.gmList.gmList[nameInputUK].reference;

    let providerOrSpecialityDropdownUK = this.lobhelper.getDesiredChildUK(insideContainer2, "providerOrSpecialityDropdown");
    let providerOrSpecialityDropdownRef = this.gmList.gmList[providerOrSpecialityDropdownUK].reference;

    this.searchState.Query.name = nameInputRef.data;

    if (locationDropdownRef.data && locationDropdownRef.data.geometry && locationDropdownRef.data.geometry.location) {
      // Handle the selected place, which is a GeoJSON feature
      this.searchState.Query.location = {
        latitude: locationDropdownRef.data.geometry.location.lat() as unknown as string,
        longitude: locationDropdownRef.data.geometry.location.lng() as unknown as string,
        distance: distanceDropdownRef.data.toString() ?? '25',
      }
      this.searchState.Extra.locationText = locationDropdownRef.data.formatted_address;
    }

    if(providerOrSpecialityDropdownRef.data.length > 0){
      this.searchState.Query.specialtiesV2 = providerOrSpecialityDropdownRef.data;
    } else {
      this.searchState.Query.specialtiesV2 = [];
    }

    this.printState = this.searchState;
    const queryParams = {
      ...omitBy(this.searchState.Query, isNull),
      skip: 0,
      limit: 5,
    };

    this.searchStateService.updateSearchCriteria(this.searchState);
    const printQueryParams = {
      ...omitBy(this.printState.Query, isNull),
      skip: 0,
      limit: 200
    }

    //only navigate to search-results after both calls return with a response
    this.loadingSpinnerService.showLoader();
    forkJoin({
      providerResults: this.searchService.getProviderResults(queryParams),
      facilityResults: this.searchService.getFacilityResults(queryParams),
    }).subscribe({
      next: () => {
        this.router.navigate(['search-results']);
      },
      error: (err) => {
        console.log('An error occurred:', err);
      },
      complete: () => {
        this.loadingSpinnerService.hideLoader();
      },
    });

    forkJoin({
      printProviderResults: this.searchService.getProviderResults(printQueryParams, true),
      printFacilityResults: this.searchService.getFacilityResults(printQueryParams, true),
    }).subscribe({
      error: (err) => {
        console.log('An error occurred:', err);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
  addToGrandmaster(viewRef: any, data: any) {
    console.log(data)
    this.grandmaster.addChildrenToThisView(viewRef, data);
    // this.firstLoad = false;
    setTimeout(() =>{console.log("4")
      console.log(this.gmList.gmList)
      console.log(this.gmList.gmList[2])}, 0)
  }

  // getDataSourceTemplateJson() {
  //   // const partialPromises = [
  //   //   this.searchService.registerPartial('recursiveTree', "../../assets/hbs_partials/recursive-tree-partial.hbs")
  //   // ];
  //   // Promise.all(partialPromises).then(() => {
  //     this.subscriptionData = this.searchService.getCareFindrJson(CURRENT_TENNANT, 'patient-search').subscribe(template => {
  //       let response = JSON.parse(template);
  //       this._data = response.componentsConfig;
  //       this.errorMessages.defaultErrorMessages = response.errorMessages;
  //       console.log(this.data);
  //       this.loadingSpinnerService.hideLoader();
  //     });
  //   // }).catch((error) =>{
  //   //   console.log("error while loading partials", error)
  //   // });
  // }
}
